<template lang="pug">
div
  .form-field-label
    span {{ label }}
    span.form-field-require-tag(v-show="required", :title="notifies.required_field")
      | *

  div(:class="[currentFieldIsInvalid ? `${main_class} valid-error` : main_class]")
    q-icon.cancel-editor-field(name="cancel", v-if="currentField", @click.stop="resetField()")

    vue-editor(
      v-model="currentField",
      ref="editor",
      :editor-toolbar="customToolbar",
      :id="name",
      @text-change="onTextChange"
    )

  span.valid-error-message(v-if="currentFieldIsInvalid") {{ valid_error_message }}
</template>

<script>
export default {
  props: {
    parentData: {
      type: Object,
      default: () => {},
    },
  },
  data: function () {
    return {
      method: this.parentData.method,
      method_limit: this.parentData.method_limit,
      grid: this.parentData.grid,
      value: this.parentData.data[0].value,
      label: this.parentData.data[0].label,
      name: this.parentData.data[0].name,
      depend_from: this.parentData.data[0].depend_from || {},
      required: this.parentData.data[0].require,
      watch: this.parentData.data[0].watch || {},
      valid_error_message: null,
      main_class: "form-field form-editor",

      customToolbar: [["bold", "italic", "underline"]],
    };
  },

  computed: {
    currentField: {
      get() {
        let form_field = this.currentForm[this.name];
        if (form_field) {
          return form_field["field"];
        } else {
          return undefined;
        }
      },
      set(value) {
        let result = {};
        if (value && value.length > 0) {
          result["field"] = value;
          result["invalid"] = this.invalid(value);
        } else {
          result["invalid"] = this.invalid();
        }
        this.$store.commit("updateFormField", { grid_name: this.grid, field: this.name, value: result });
        if (!result["invalid"]) {
          this.$store.commit("resetFormFieldValue", {
            grid_name: this.grid,
            field: "invalid_fields",
            value: this.name,
          });
        }
      },
    },

    fieldDependency() {
      return this.checkDependency();
    },
  },

  watch: {
    fieldDependency(newVal, oldVal) {},
  },

  created() {
    this.watchSimpleFieldParents();
  },

  beforeMount() {
    this.$store.commit("createFormField", { grid_name: this.grid, field: this.name });
    this.setField(this.value);
  },

  methods: {
    setField(val) {
      this.currentField = val;
    },

    setRequire(val) {
      this.required = val;
      let result = {};
      if (val) {
        this.resetField();
      } else {
        let result = {};
        result["invalid"] = false;
        this.$store.commit("updateFormField", { grid_name: this.grid, field: this.name, value: result });

        this.$store.commit("resetFormFieldValue", {
          grid_name: this.grid,
          field: "invalid_fields",
          value: this.name,
        });
      }
    },

    onTextChange(val) {
      // check if paste image
      if (val.ops.find(item => item.insert?.image)) {
        // use regexp for find and replace img
        const reg = new RegExp("<img.+?(?=>).");
        const newVal = this.currentField.replace(reg, "");
        // find editor element, need because with paste image vue editor not over-rendered
        // from this.currentField changes
        const editorEl = this.$refs["editor"].$el.querySelector(".ql-editor");
        this.setField(newVal);
        editorEl.innerHTML = newVal;
        // notife user
        this.$q.notify(this.notifies.attachments_not_allowed);
      }
    },

    resetField() {
      this.currentField = "";
    },

    invalid(val = undefined) {
      if (this.required) {
        if (val && val.length > 0) {
          this.valid_error_message = null;
          return false;
        } else {
          this.valid_error_message = this.notifies.not_empty;
          return true;
        }
      } else {
        this.valid_error_message = null;
        return false;
      }
    },
  },
};
</script>

<style lang="scss">
@import "../../../../assets/styles/forms/fields/editor";
</style>
